import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SsoService {
  private token = '';
  headers = {
    headers: new HttpHeaders()
      .set('token', this.token)
      .set('Content-Type', 'application/json'),
  };
  constructor(private http: HttpClient) { }

  // App ID:
  // 0197d38f-3ed7-7236-abea-1f9172443efc
  // Client ID:
  // 0197d38f-3ed7-7236-abea-1f9172443efc
  // Client Secret:
  // FEzdLbOXIUfinDxJK3nXQiWwGvPpwFANNlRovTrLZSP1ca28eL78cthBsjQGXl12
  // Redirect Login Url:
  // https://opac-mirror.kku.ac.th/kku-sso
  // Redirect Logout Url:
  // https://opac-mirror.kku.ac.th

  // App ID:
  // 0197d38b-cbea-7cce-9d83-1be4822d8138
  // Client ID:
  // 0197d38b-cbea-7cce-9d83-1be4822d8138
  // Client Secret:
  // bEkBuRF6n7ZEPSkBWHb8yUWGc0rj4kQVl8kUmHJaD7XMpKX62vx7G5l9QC3eAMRp
  // Redirect Login Url:
  // https://5jwj52m6-4200.asse.devtunnels.ms/kku-sso
  // Redirect Logout Url:
  // https://5jwj52m6-4200.asse.devtunnels.ms
  // 5jwj52m6-4200.asse.devtunnels.ms
  //KKU SSO API

  //V2
  // App ID:
  // 0197d38f-3ed7-7236-abea-1f9172443efc
  // Client ID:
  // 0197d38f-3ed7-7236-abea-1f9172443efc
  // Client Secret:
  // FEzdLbOXIUfinDxJK3nXQiWwGvPpwFANNlRovTrLZSP1ca28eL78cthBsjQGXl12
  // Redirect Login Url:
  // https://opac-mirror.kku.ac.th/kku-sso
  // getAccessToken(code: string) {
  //   // Define the request object
  //   const ssoRequest: SsoRequest = {
  //     code: code,
  //     redirectUrl: 'https://opac-mirror.kku.ac.th/kku-sso',
  //     clientId: '0197d38f-3ed7-7236-abea-1f9172443efc',
  //     clientSecret: 'FEzdLbOXIUfinDxJK3nXQiWwGvPpwFANNlRovTrLZSP1ca28eL78cthBsjQGXl12'
  //   };
  //   return this.http.post<any>(this.apiUrl, ssoRequest, this.headers);
  // }

  //https://opac.kku.ac.th/ssoapi/api/sso
  getAccessToken(code: string) {
    // Define the request object
    const ssoRequest = {
      code: code,
    };
    // Define the API URL from environment variables or default
    const apiUrl =
      environment.apiSSOAuth.find((api) => api.name === 'KKU-ssoapi')?.url ||
      'https://opac.kku.ac.th/ssoapi/api/sso';
    return this.http.post<any>(apiUrl, ssoRequest, this.headers);
  }

  //https://ssonext.kku.ac.th/login?app=0197d38b-cbea-7cce-9d83-1be4822d8138
  getKKULoginLogOutUrl(isLogin: boolean): string {
    const apiSSOAuth = environment.apiSSOAuth; // Use environment variable or default
    // apiSSOAuth: [
    //   { "name": "UBU", "url": "https://medias.lib.ubu.ac.th/ubulogin/api/login", "token": "", "description": "UBU" },
    //   { "name": "KKU-login-logout", "url": "https://ssonext.kku.ac.th/login?app=", "token": "0197d38f-3ed7-7236-abea-1f9172443efc", "description": "KKU login,logut token = appID  /logout?app=<AppID> /login?app=<AppID>" },
    //   { "name": "KKU-ssoapi", "url": "https://opac.kku.ac.th/ssoapi/api/sso", "token": "", "description": "KKU SSO" },
    // ],
    // /login?app=<AppID>

    // Find the KKU login URL from the environment configuration
    const kkuLoginUrl = apiSSOAuth.find(
      (api) => api.name === 'KKU-login-logout'
    );
    if (kkuLoginUrl) {
      if (isLogin) {
        // If isLogin is true, return the login URL
        return `${kkuLoginUrl.url}/login?app=${kkuLoginUrl.token}`;
      } else {
        // If isLogin is false, return the logout URL
        return `${kkuLoginUrl.url}/logout?app=${kkuLoginUrl.token}`;
      }
    }

    return '';
  }

  // For KMITL
  getKMITLLoginLogOutUrl(isLogin: boolean): string {
    const apiSSOAuth = environment.apiSSOAuth; // Use environment variable or default

    // Find the KMITL login URL from the environment configuration
    const kmitlLoginUrl = apiSSOAuth.find(
      (api) => api.name === 'KMITL-login'
    );
    const kmitlLogoutUrl = apiSSOAuth.find(
      (api) => api.name === 'KMITL-logout'
    );

    if (isLogin) {
      return `${kmitlLoginUrl.url}`;
    } else {
      return `${kmitlLogoutUrl.url}`;
    }

    // if (kmitlLoginUrl) {
    //   if (isLogin) {
    //     // If isLogin is true, return the login URL
    //     return `${kmitlLoginUrl.url}`;
    //   } else {
    //     // If isLogin is false, return the logout URL
    //     return `${kmitlLogoutUrl.url}`;
    //   }
    // }

    // return '';
  }




  public decryptKMITL(cipherText: string, key: string = '5349af845586f1a4e84f84c44f9524d7'): string {
    const iv = CryptoJS.enc.Utf8.parse('577d5297b2339950');
    const keyBytes = CryptoJS.enc.Utf8.parse(key);

    const decrypted = CryptoJS.AES.decrypt(cipherText, keyBytes, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  // For YRU
  getYRUOAuthInfo() {
    return environment.apiSSOAuth.find(api => api.name === 'YRU');
  }

  getYRUToken(code: string): Observable<any> {
    const yru = this.getYRUOAuthInfo();
    const body = new HttpParams()
      .set('grant_type', 'authorization_code')
      .set('client_id', yru?.clientId)
      .set('client_secret', yru?.clientSecret)
      .set('redirect_uri', yru?.redirectUri)
      .set('code', code);

    return this.http.post<any>(yru?.tokenUrl, body.toString(), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
    });
  }

  getYRUUserInfo(accessToken: string): Observable<any> {
    const yru = this.getYRUOAuthInfo();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${accessToken}`);
    return this.http.get<any>(yru?.userUrl, { headers });
  }

  getYRULoginLogOutUrl(isLogin: boolean,redirectUri: string): string {
    const yru = this.getYRUOAuthInfo();
    if (isLogin) {

      return `${yru?.authUrl}?client_id=${yru?.clientId}&redirect_uri=${yru?.redirectUri}&response_type=code`;
    } else {
      return `${yru?.logoutUrl}?redirect_uri=${redirectUri}`;
    }
  }
}

// interface SsoRequest
interface SsoRequest {
  code: string;
  redirectUrl: string;
  clientId: string;
  clientSecret: string;
}
